export default __webpack_public_path__ + "static/media/windows_system_metrics.96ce0c88.md";